<header class="d-flex align-items-center pe-2 gap-2">
  <app-menu-header></app-menu-header>
  <h1
    class="text-wrap text-truncate w-100 overflow-hidden flex-grow-1"
    [style]="`font-size:clamp(0.7rem, ${70 / ((title$ | async)?.length ?? 10)}vw, 2rem);`"
    [title]="title$ | async"
  >
    {{ title$ | async }}
  </h1>
  <a
    *appPermission="permissions.notification.view"
    class="position-relative"
    data-bs-toggle="tooltip"
    title="Meldingen"
    routerLink="meldingen"
  >
    <i class="bi bi-bell"></i>
    @if (unreadNotificationsCount$ | async; as unreadCount) {
      @if (unreadCount > 0) {
        <span
          class="notification-count-badge position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
        >
          {{ unreadCount >= 10 ? '9+' : unreadCount }}
        </span>
      }
    }
  </a>
  <app-user-control [userInfo]="(userInfo$ | async) ?? undefined"></app-user-control>
</header>
